import { render, staticRenderFns } from "./cosForm.vue?vue&type=template&id=484babe1&scoped=true&"
import script from "./cosForm.vue?vue&type=script&lang=js&"
export * from "./cosForm.vue?vue&type=script&lang=js&"
import style0 from "./cosForm.vue?vue&type=style&index=0&id=484babe1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484babe1",
  null
  
)

export default component.exports